export default __webpack_public_path__ + "static/media/404-page-not-found.bbf5aa40.svg";